import api from "@/api/apiClient";
import type { SystemDefault } from "@/models/system-default";
import { useQuery } from "@tanstack/react-query";

export default function useSystemDefaults() {
    const { data: systemDefaults, isLoading } = useQuery<SystemDefault[]>({
        queryKey: ['systemDefaults'],
        queryFn: () => api.get('/system-defaults/all').then(res => res.data.data),
        staleTime: 1000 * 60 * 5, // 5 minutes
    });
    
    return {
        systemDefaults,
        isLoading,
    };
}